import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import CustomFieldVisibilityIcon from "./custom-field-visibility-icon";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomFieldControlsButtons",
  components: {
    InlinePrompt,
    CustomFieldVisibilityIcon
  },
  props: {
    allowEdit: {
      type: Boolean,
      default: true
    },
    allowDelete: {
      type: Boolean,
      default: true
    },
    allowOrder: {
      type: Boolean,
      default: true
    },
    deleteConfirmation: {
      type: String,
      default: "Confirm Delete Custom Field"
    },
    allowVisibility: {
      type: Boolean,
      default: true
    },
    visibilityType: {
      type: String,
      default: "none",
      validator(value) {
        var _context;
        return _includesInstanceProperty(_context = ["none", "compact", "full"]).call(_context, value);
      }
    }
  },
  computed: {
    visibilityTooltipText() {
      const textMap = {
        none: this.$t("custom-fields.visibility.text.none"),
        compact: this.$t("custom-fields.visibility.text.compact"),
        full: this.$t("custom-fields.visibility.text.full")
      };
      return textMap[this.visibilityType];
    }
  },
  watch: {
    visibilityType() {
      this.$nextTick(() => {
        // Reset visibility tooltip so the message gets updated
        $(this.$refs.visibilityTooltip).tooltip("dispose").tooltip("show");
      });
    }
  },
  methods: {
    handleEditClick() {
      this.$emit("edit");
    },
    handleDeleteClick() {
      this.$emit("delete");
    },
    handleVisibility() {
      this.$emit("visibility");
    }
  }
});